import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

const TrashIcon = (props) => (
  <SvgIcon {...props}>
    <polyline fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
      5,8 7,22 17,22 19,8 "/>
    <line fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="4" y1="5" x2="20" y2="5"/>
    <polyline fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
      16,5 14,2 10,2 8,5 "/>
    <line fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="9" y1="9" x2="10" y2="19"/>
    <line fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="15" y1="9" x2="14" y2="19"/>
  </SvgIcon>
);

export default TrashIcon;



// WEBPACK FOOTER //
// ./src/icons/TrashIcon.jsx